import { render, staticRenderFns } from "./MeasureDetail.vue?vue&type=template&id=023b8470"
import script from "./MeasureDetail.vue?vue&type=script&lang=js"
export * from "./MeasureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports